import React, { memo, useCallback, useEffect, useMemo } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { EntityCrudActions, EntityListActions } from 'actions';
import { RATES } from 'constants/Entities';
import NewEntityList from 'containers/components/NewEntityList';
import { getLiteral } from 'utils/getLiteral';
import { intercomHideAndShow } from 'utils/intercom';
import { warningToast } from 'utils/toast';

import CONFIG from './TableConfig';

const mapStateToProps = (state) => {
    const permissions = state.config.permission;
    return {
        locale: state.config.userData.locale,
        canCreate: permissions ? permissions.rates_add : false,
    };
};

const mapDispatchToProps = (dispatch) => ({
    initEntityCrud: bindActionCreators(EntityCrudActions, dispatch).init,
    setUseLazyLoad: bindActionCreators(EntityListActions, dispatch).setUseLazyLoad,
});

const Content = memo(({ initEntityCrud, setUseLazyLoad, locale, canCreate }) => {
    useEffect(() => {
        setUseLazyLoad(RATES, true);
    }, [setUseLazyLoad]);

    const tableParams = useMemo(() => {
        return {
            date: {
                getLocale: () => locale,
            },
        };
    }, [locale]);

    const config = useMemo(() => CONFIG(tableParams), [tableParams]);

    const handleOnClickRow = useCallback(
        ({ data }) => {
            if (data.rawData.exceedsProducts) {
                warningToast({
                    text: getLiteral('label_price_list_exceeds_products'),
                });
                return;
            }
            intercomHideAndShow('hide');
            initEntityCrud({ entity: RATES, id: data.id, avoidRedirects: true });
        },
        [initEntityCrud],
    );

    const emptyViewProps = useMemo(
        () => ({
            canCreate,
            onCreate: () => initEntityCrud({ entity: RATES, avoidRedirects: true }),
        }),
        [canCreate, initEntityCrud],
    );

    return (
        <div className="rates-table">
            <NewEntityList
                id="fm-grid-rates"
                entity={config.entity}
                config={config}
                initOnReady={true}
                useLazyLoad={true}
                onClickRow={handleOnClickRow}
                emptyViewProps={emptyViewProps}
            />
        </div>
    );
});

export default connect(mapStateToProps, mapDispatchToProps)(Content);
